import { getAll } from '@/api/collectiviteAvecDeclarationTlpe';
import { getCountDeclarableAuFilDeLeauAsync } from '@/api/gabed/materiel';
import genererCritereRechercheCollectivite
  from '@/services/gabed/collectivite/genererCritereRecherche';
import { getAll as getAllCommandeTlpe } from '@/api/gabed/commandeTlpe';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import {
  SET_CRITERE,
  SET_LAST_PAYLOAD,
  RESET_CRITERE,
  RESET_STATE,
} from '@/store/mutation-type';
import { DEMONTAGE_AU_FIL_DE_L_EAU, MONTAGE_AU_FIL_DE_L_EAU } from '@/configuration/gabed/tlpe/tlpeConf';
import { cloneDeep } from 'lodash';

function initialState() {
  const critere = genererCritereRechercheCollectivite();
  critere.anneeDeclaration = new Date().getFullYear();
  return {
    criteresRecherche: critere,
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [SET_CRITERE](state, criteresRecherche) {
    state.criteresRecherche = criteresRecherche;
  },
  [RESET_CRITERE](state) {
    state.criteresRecherche = initialState().criteresRecherche;
  },
  [SET_LAST_PAYLOAD](state, lastPayload) {
    state.lastPayload = lastPayload;
  },
  [RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadDeclarationAuFilDeLeau({ commit, rootState, getters }, data) {
    data.query = cloneDeep(getters.criteresRecherche);
    if (data.query.tiers && data.query.tiers !== undefined) {
      data.query.tiersIds = data.query.tiers.map(t => t.id);
      delete data.query.tiers;
    }
    const anneeDeclaration = data.query.anneeDeclaration;
    data.query.societeId = rootState.societe.societeActiveId;
    let collectivites = [];
    let count = 0;
    const { items, totalCount } = (await getAll(data)).data.result;
    collectivites = items;
    count = totalCount;
    const collectivitesIds = collectivites.map(c => c.id);
    if (collectivitesIds.length > 0 && anneeDeclaration !== undefined) {
      const params = {
        collectivitesIds: collectivitesIds,
        annee: anneeDeclaration,
      };
      const paramsPrevAnnee = {
        collectivitesIds: collectivitesIds,
        annee: anneeDeclaration - 1,
      };
      const paramsCommandesTlpe = {
        query: {
          tiersId: collectivitesIds,
          anneesDeclaration: [anneeDeclaration],
          societeId: data.query.societeId,
          typesDeclaration: [DEMONTAGE_AU_FIL_DE_L_EAU, MONTAGE_AU_FIL_DE_L_EAU],
        },
        limit: NO_PAGINATION,
      };
      const { declarable, declarablePrevAnnee, commandesTlpe } = await Promise.all([
        getCountDeclarableAuFilDeLeauAsync(params),
        getCountDeclarableAuFilDeLeauAsync(paramsPrevAnnee),
        getAllCommandeTlpe(paramsCommandesTlpe),
      ]).then(([declarable, declarablePrevAnnee, commandes]) => {
        return {
          declarable: declarable.data.result,
          declarablePrevAnnee: declarablePrevAnnee.data.result,
          commandesTlpe: commandes.data.result.items,
        };
      });
      collectivites.forEach(collectivite => {
        collectivite.selected = false;
        collectivite.commandes = commandesTlpe.filter((cmd) => {
          return cmd.intervenants.map((int) => int.tiersId).includes(collectivite.id);
        }).map((cmd) => {
          return { id: cmd.id, code: cmd.code };
        });
        if (collectivite.commandes.length === 0) collectivite.commandes = null;
        const decCol = declarable[collectivite.id];
        if (decCol) {
          collectivite.nombreMaterielMontageNonDeclare = decCol.nombreMaterielMontageNonDeclare;
          collectivite.nombreMaterielDemontageNonDeclare = decCol.nombreMaterielDemontageNonDeclare;
        } else {
          collectivite.nombreMaterielMontageNonDeclare = null;
          collectivite.nombreMaterielDemontageNonDeclare = null;
        }
        const decColPrevAnnee = declarablePrevAnnee[collectivite.id];
        if (decColPrevAnnee) {
          collectivite.nombreMaterielMontageNonDeclarePrevAnnee = decColPrevAnnee
            .nombreMaterielMontageNonDeclare;
          collectivite.nombreMaterielDemontageNonDeclarePrevAnnee = decColPrevAnnee
            .nombreMaterielDemontageNonDeclare;
        } else {
          collectivite.nombreMaterielMontageNonDeclarePrevAnnee = null;
          collectivite.nombreMaterielDemontageNonDeclarePrevAnnee = null;
        }
      });
    }
    commit(SET_LAST_PAYLOAD, data);
    return {
      data: collectivites,
      count: count,
    };
  },
};

const getters = {
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
